module.exports = __webpack_public_path__ + "126e3505907e02ed1fdc86058cb4ce3a.woff2";